import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Button from "../../atoms/Button/Button";
import "./CitizenSection.css";

const CitizenSection = () => (
  <section className="soft" id="particuliers">
    <div className="wrap">
      <div className="split">
        <div className="citizen-text">
          <span className="eyebrow">Un outil pour tous les usages</span>
          <h2 className="citizen-h2">
            La prévention commence <br /> par un geste simple
          </h2>
          <div className="citizen-rule" />
          <p className="citizen-body">
            <br />
            En France, une grande partie des feux de forêt est d'origine
            humaine accidentelle.
          </p>
          <p className="citizen-body">
            <br />
            Avant une sortie, une randonnée ou
            une activité en zone naturelle, un simple accès à la carte permet d’adapter
            ses comportements et de ne pas contribuer aux risques de départs de feu.
          </p>
          <br />
          <p className="citizen-body citizen-body-label">
            ensemblepourlaforêt.fr rend cette information :
          </p>
          <ul className="citizen-checklist citizen-checklist--indented">
            <li>
              <CheckCircleIcon className="citizen-check-icon" />
              <strong>Accessible à tous</strong>
            </li>
            <li>
              <CheckCircleIcon className="citizen-check-icon" />
              <strong>Gratuite</strong>
            </li>
            <li>
              <CheckCircleIcon className="citizen-check-icon" />
              <strong>Simple à consulter en quelques secondes</strong>
            </li>
          </ul>

          <div className="citizen-cta-group">
            <a
              href="/notifications"
              target="_blank"
              rel="noopener noreferrer"
              className="citizen-cta-item"
            >
              <Button label="Carte des risques de feux de forêt sur 36 heures" variant="orange" />
            </a>

            <a
              href="https://www.facebook.com/share/r/1BzjMwGuS7/"
              target="_blank"
              rel="noopener noreferrer"
              className="citizen-video-card citizen-cta-item"
            >
              <img
                className="citizen-video-logo"
                src="/images/Service-public-seul.png"
                alt="Service-Public.fr"
              />
              <span className="citizen-video-label">Vidéo · Service-Public.fr</span>
              <span className="citizen-video-title">
                Feux de forêt : les bons gestes pour éviter de les déclencher
              </span>
            </a>
          </div>
        </div>
        <div className="citizen-visual">
          <img
            className="section-illustration"
            src="/images/humain1.png"
            alt="Un citoyen consulte la carte des risques avant une sortie en forêt"
          />
        </div>
      </div>
    </div>
  </section>
);

export default CitizenSection;